module.exports = __webpack_public_path__ + "img/32t.prt.435de17b.jpg";